import type { LoadingStateProps } from './LoadingState.types'
import './LoadingState.css'

export function LoadingState({ label }: LoadingStateProps) {
  return (
    <div className="loading-state">
      <div className="spinner-border text-secondary" role="status" aria-hidden="true" />
      <span className="text-muted">Loading {label}…</span>
    </div>
  )
}
